import { Box, Portal } from '@chakra-ui/react';
import { useFocus } from 'modules/Editor/components/Focus';
import { useAppSelector } from 'modules/Editor/store';
import { RootState, useAppStore } from 'modules/Editor/store';
import { selectWidgets } from 'modules/Editor/store/infographSelector';
import { selectIsActiveWidget } from 'modules/Editor/store/widgetSelector';
import { MouseEvent, useCallback } from 'react';
import { isResponsiveWidget } from 'widgets/ResponsiveWidgets/ResponsiveWidget.helpers';
import { useMultiEditConfig } from 'widgets/store/MultiEditConfigProvider';

import { MultiEditWidgetConfig } from '../../Widget.types';
import { useWidget } from '../useWidget';

interface WidgetToolbarProps {
  children: React.ReactNode;
  multiEditConfig?: MultiEditWidgetConfig<any>;
}

// Renders the selected widgets toolbar
export const WidgetToolbar = ({ children, multiEditConfig }: WidgetToolbarProps) => {
  const { widgetToolbarPortalRef } = useFocus();
  const { widgetId } = useWidget();
  const { addMultiSelectOptions } = useMultiEditConfig();
  const isWidgetSelected = useAppSelector(selectIsActiveWidget(widgetId));
  const store = useAppStore();

  const onDoubleClick = useCallback((e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  // assign the multi select options to the widget
  if (multiEditConfig) addMultiSelectOptions(widgetId, multiEditConfig);

  if (!isWidgetSelected) return null;

  // Responsive widget widgets have their own toolbar
  if (isResponsiveWidget(widgetId, selectWidgets(store.getState() as RootState))) return null;

  return (
    <Portal containerRef={widgetToolbarPortalRef as React.RefObject<HTMLElement | null> | undefined}>
      <Box zIndex='toolbar' onDoubleClick={onDoubleClick}>
        {children}
      </Box>
    </Portal>
  );
};
